export const SOCIAL_LINKS = {
  email: 'mailto:hyunjineeey@gmail.com',
  github: 'https://github.com/hyunjineeey',
  linkedIn: 'https://www.linkedin.com/in/hyunjineeey/'
} 